import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { Pagination } from '@utils/models/Pagination';
import { TaskFilter } from '@utils/models/TaskFilter';
import { useQuery } from 'react-query';

import { crmConstants } from 'modules/crm';

export const useLeadTaskFilter = (props: {
  page?: number;
  size?: number;
  employeeList?: number[];
  leadTaskTypeIds?: number[];
  leadTaskStatusFilter?: string;
  startTimestamp?: number;
  finishTimestamp?: number;
}) => {
  const { page = 1, size = 10, ...args } = props;

  return useQuery<{ count: number; leadTaskList: Pagination<TaskFilter> }>({
    queryKey: [crmConstants.queryKeys.LEAD_TASK_FILTER, props],
    queryFn: async () => {
      const res = await $api.post('/v1/lead-task/filter', {
        page,
        size,
        ...args
      });

      const data: { count: number; leadTaskList: Pagination<TaskFilter> } = res?.data?.data;

      return data
        ? ({
            ...data,
            leadTaskList: {
              ...data?.leadTaskList,
              data: data?.leadTaskList?.data?.map(item => ({
                ...item,
                closedDate: timeStampToDate({ date: item?.closedDate, timeStamp: item?.closedTimestamp }),
                createdDate: item?.createdDate
                  ? timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp })
                  : item?.createdDate,
                deadlineFinish: item?.deadlineFinish
                  ? timeStampToDate({ date: item?.deadlineFinish, timeStamp: item?.deadlineFinishTimestamp })
                  : item?.deadlineFinishTimestamp,
                deadlineStart: item?.deadlineStart
                  ? timeStampToDate({ date: item?.deadlineStart, timeStamp: item?.deadlineStartTimestamp })
                  : item?.deadlineStartTimestamp
              }))
            }
          } as { count: number; leadTaskList: Pagination<TaskFilter> })
        : data;
    },
    enabled: !!args?.startTimestamp && !!args?.finishTimestamp
  });
};
